// import { recommendations } from './mock-own-brands';

import axios from 'axios';

import { Site } from '@zooplus/commons-lang';

export const OwnBrandService = () => {
  const getData = async (site: Site) => {
    try {
      // Make the GET request and store the response in a variable
      const response = await axios.get(
        `https://www.${site.domain}/zootopia-recommender/api/v4/sites/${site.id}/${site.language}/pages/ob_landing/recommendations`,
      );

      // Store the data in a variable
      const data = response.data;

      console.log('Data:', data);

      // Use `data` elsewhere or return it
      return data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error('Error:', error.message);
      } else {
        console.error('Unknown error occurred');
      }

      // Handle error or return a default value
      return null;
    }
  };
  const getOwnBrandRecommendations = async (isMock: boolean, site: Site) => {
    // await fetch(
    //   `https://www.${site.domain}/zootopia-recommender/api/v3/sites/${site.id}/${site.language}/pages/ob_landing/recommendations`,
    //   {
    //     method: 'GET',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   },
    // )
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     return response.json();
    //   })
    //   .then((data) => console.log(data))
    //   .catch((error) => console.error('Error:', error));

    // console.log('siteDomain-> ' + JSON.stringify(site));
    // if (isMock) {
    //   const mappedRecommendations = recommendations.map((elem: any) => {
    //     return {
    //       [elem.name]: elem.recommendations.map((item: any) => ({
    //         articleShopId: item.as_id,
    //         productShopId: item.product_id,
    //         productName: item.product_name,
    //         variantName: item.variant_name,
    //         rating: item.rating,
    //         votes: item.review_count,
    //         pictureUrl: item.image,
    //         pdpUrl: item.link,
    //         originalPrice: item.current_price,
    //         unitPrice: item.unit_price,
    //         unitPriceFormatted: item.unit_price_label,
    //         currency: item.currency,
    //       })),
    //     };
    //   });
    //   const catData = mappedRecommendations.slice(0, 4);
    //   const dogData = mappedRecommendations.slice(4, 7);
    //   console.log(catData);

    // } else {
    //   const productRecoAwait =
    //   console.log(productRecoAwait);

    try {
      const responseBody = await getData(site);
      if (Array.isArray(responseBody)) {
        const mappedRecommendations = responseBody.map((elem: any) => {
          // console.log('name', elem.name);
          // console.log('elem', elem);
          // return {
          //   [elem.name]: elem.recommendations.map((item: any) => ({
          //     articleShopId: item.as_id,
          //     productShopId: item.product_id,
          //     productName: item.product_name,
          //     variantName: item.variant_name,
          //     rating: item.rating,
          //     votes: item.review_count,
          //     pictureUrl: item.image,
          //     pdpUrl: item.link,
          //     originalPrice: item.current_price,
          //     originalPriceFormatted: item.current_price_label,
          //     unitPrice: item.unit_price,
          //     unitPriceFormatted: item.unit_price_label,
          //     currency: item.currency,
          //   })),

          // };
          return {
            [elem.name]: elem.recommendations,
          };
        });
        const catData = mappedRecommendations.slice(0, 4);
        const dogData = mappedRecommendations.slice(4, 7);

        return { catData, dogData };
      } else {
        console.log('Response body is not an array or string.');
      }
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      return {};
    }
    return { catData: [], dogData: [] };
    // }
  };

  return {
    getOwnBrandRecommendations,
  };
};
